import { authHeader } from "../helpers/authHeader.js";
import Axios from "axios";
import { dictionary } from "../helpers";
import { tools } from "../helpers";
import { config } from "../helpers";

export const bookingService = {
  lookupNames,
  lookupAddresses,
  loadMatchingTerminalAddress,
  sendBooking,
  sendPickupDelivery,
  searchBookings,
  loadBookingEvents
};

function lookupNames(address) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    address: address.address,
    zip: address.zip,
    country_code: address.country
  };

  return Axios.post(
    `${config.apiUrlTools}/Tools/LookupNames`,
    //`https://localhost:5001/Tools/LookupNames`,
    body,
    requestOptions
  ).then(handleResponse);
}

function lookupAddresses(address) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    name: address.name,
    country_code: address.country
  };

  return Axios.post(
    `${config.apiUrlTools}/Tools/LookupAddresses`,
    body,
    requestOptions
  ).then(handleResponse);
}

function loadMatchingTerminalAddress(customerId, inboundOutboundType, address) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    customerId: customerId,
    inboundOutboundType: inboundOutboundType,
    address: { zip: address.zip, country_code: address.country }
  };

  // tools.logAxios(
  //   `${config.apiUrlTools}/Tools/LoadMatchingTerminalAddress`,
  //   body,
  //   requestOptions
  // );

  return Axios.post(
    `${config.apiUrlTools}/Tools/LoadMatchingTerminalAddress`,
    body,
    requestOptions
  ).then(handleResponse);
}

function sendBooking(booking, user) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      client: booking.account.id,
      password: config.bookingAPIPwd
    }
  };

  const bookingType =
    user.settings &&
    user.settings.find(
      setting => setting.type === dictionary.settings.booking_type
    )
      ? user.settings.find(
          setting => setting.type === dictionary.settings.booking_type
        ).value
      : "";

  if (bookingType == dictionary.constants.booking_types.courier) {
    const goods = [];

    booking.goods.forEach(goodsItem => {
      goods.push({
        cll: tools.parseDouble(goodsItem.cll),
        unittype: goodsItem.unittype ? goodsItem.unittype.external_key : "",
        grossweight: tools.parseDouble(goodsItem.weight),
        freightweight: tools.parseDouble(goodsItem.weight),
        length: goodsItem.length,
        width: goodsItem.width,
        height: goodsItem.height,
        cbm: tools.parseDouble(goodsItem.cbm),
        palletspaces: tools.parseDouble(goodsItem.pallet_spaces),
        description: tools.uriEncodeString(goodsItem.description),
        reference: tools.uriEncodeString(goodsItem.reference),
        adr: goodsItem.adr,
        unno: goodsItem.adr ? tools.uriEncodeString(goodsItem.un_no) : "",
        packinggroup: goodsItem.adr ? tools.uriEncodeString(goodsItem.packing_group) : "",
        slv: goodsItem.slv,
        pipes: goodsItem.pipes
      });
    });

    const body = {
      booking: {
        customerno: booking.account.id,
        bookername: tools.uriEncodeString(user.first_name + " " + user.last_name),
        reference: tools.uriEncodeString(booking.reference_1),
        secondaryreference: tools.uriEncodeString(booking.reference_2),
        comment: tools.uriEncodeString(booking.remark),
        commenttodriver: tools.uriEncodeString(
          (booking.allow_no_signature
            ? "\n" + dictionary.texts.allow_no_signature
            : "") +
            (booking.photo_documentation
              ? dictionary.texts.photo_documentation
              : "")
        ),
        cartype: booking.vehicle_type.external_key,
        insuranceamount: booking.insurance
          ? tools.parseDouble(booking.insurance_amount)
          : 0.0,
        notificationemail:
          booking.notification && booking.notification.notification_to_booker
            ? booking.notification.booker_email
            : "",
        stops: [
          {
            stoporder: 0,
            address: {
              name1: tools.uriEncodeString(booking.pickup.address.name),
              address1: tools.uriEncodeString(booking.pickup.address.address),
              zip: tools.uriEncodeString(booking.pickup.address.zip),
              city: tools.uriEncodeString(booking.pickup.address.city),
              countrycode: tools.uriEncodeString(booking.pickup.address.country),
              coordinates: {
                lat: booking.pickup.address.lat,
                lon: booking.pickup.address.lon
              }
            },
            instructions: tools.uriEncodeString(booking.pickup.address.address2),
            fromtime:
              booking.pickup.timewindow.from.date +
              "T" +
              booking.pickup.timewindow.from.time +
              ":00.000",
            totime:
              booking.pickup.timewindow.to.date +
              "T" +
              booking.pickup.timewindow.to.time +
              ":00.000",
            contactname: tools.uriEncodeString(booking.pickup.contact.name),
            contactphone: tools.uriEncodeString(booking.pickup.contact.phone)
          },
          {
            stoporder: 1,
            address: {
              name1: tools.uriEncodeString(booking.delivery.address.name),
              address1: tools.uriEncodeString(booking.delivery.address.address),
              zip: tools.uriEncodeString(booking.delivery.address.zip),
              city: tools.uriEncodeString(booking.delivery.address.city),
              countrycode: tools.uriEncodeString(booking.delivery.address.country),
              coordinates: {
                lat: booking.delivery.address.lat,
                lon: booking.delivery.address.lon
              }
            },
            instructions: tools.uriEncodeString(booking.delivery.address.address2),
            fromtime:
              booking.delivery.timewindow.from.date +
              "T" +
              booking.delivery.timewindow.from.time +
              ":00.000",
            totime:
              booking.delivery.timewindow.to.date +
              "T" +
              booking.delivery.timewindow.to.time +
              ":00.000",
            contactname: tools.uriEncodeString(booking.delivery.contact.name),
            contactphone: tools.uriEncodeString(booking.delivery.contact.phone)
          }
        ],
        goods: goods
      }
    };

    // tools.logAxios(
    //   `${config.apiUrlBooking_BookingEndpoint}/sendBooking`,
    //   body,
    //   requestOptions
    // );

    return Axios.post(
      `${config.apiUrlBooking_BookingEndpoint}/sendBooking`,
      body,
      requestOptions
    ).then(handleResponse);
  } else if (bookingType == dictionary.constants.booking_types.distribution) {
    let orders = [];
    booking.goods.forEach(goods => {
      orders.push({
        order: {
          externalreference:
            booking.account.id + "_" + new Date().getTime() + goods.id, //not used when webbooking
          type: 1, //always pickup
          customerno: booking.account.id,
          address: {
            name1: tools.uriEncodeString(booking.pickup.address.name),
            address1: tools.uriEncodeString(booking.pickup.address.address),
            zip: tools.uriEncodeString(booking.pickup.address.zip),
            city: tools.uriEncodeString(booking.pickup.address.city),
            countrycode: tools.uriEncodeString(booking.pickup.address.country),
            coordinates: {
              lat: booking.pickup.address.lat,
              lon: booking.pickup.address.lon
            }
          },
          instructions: tools.uriEncodeString(booking.pickup.address.address2),
          fromtime:
            booking.pickup.timewindow.from.date +
            "T" +
            booking.pickup.timewindow.from.time +
            ":00.000",
          totime:
            booking.pickup.timewindow.to.date +
            "T" +
            booking.pickup.timewindow.to.time +
            ":00.000",
          contactname: tools.uriEncodeString(booking.pickup.contact.name),
          contactphone: tools.uriEncodeString(booking.pickup.contact.phone),
          cll: tools.parseDouble(goods.cll),
          unittype: goods.unittype ? goods.unittype.external_key : "",
          grossweight: tools.parseDouble(goods.weight),
          freightweight: tools.parseDouble(goods.weight),
          length: goods.length,
          width: goods.width,
          height: goods.height,
          cbm: tools.parseDouble(goods.cbm),
          palletspaces: tools.parseDouble(goods.pallet_spaces),
          description: tools.uriEncodeString(goods.description),
          reference: tools.uriEncodeString(goods.reference),
          unno: tools.uriEncodeString(goods.adr ? goods.un_no : ""),
          packinggroup: tools.uriEncodeString(goods.adr ? goods.packing_group : "")
        }
      });
    });

    const body = {
      orders: orders
    };

    return Axios.post(
      `${config.apiUrlBooking_BookingEndpoint}/sendPickupDeliveries`,
      body,
      requestOptions
    ).then(handleResponse);
  }
}

function sendPickupDelivery(order, client) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      client: client,
      password: config.bookingAPIPwd
    }
  };

  return Axios.post(
    `${config.apiUrlBooking_BookingEndpoint}/sendPickupDelivery`,
    order,
    requestOptions
  ).then(handleResponse);
}

function searchBookings(user, fromDate, toDate, reference, stopName) {
  let companyIds = [];

  if (user && user.accounts && user.accounts) {
    user.accounts.forEach(account => {
      companyIds.push(account.id);
    });
  }

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      client: companyIds.join(","),
      password: config.bookingAPIPwd
    }
  };

  const body = {
    fromdate: fromDate + "T" + "00:00:00.000",
    todate: toDate + "T" + "23:59:59.999",
    reference: tools.uriEncodeString(reference),
    name: tools.uriEncodeString(stopName),
    limit: 100
  };

  // tools.logAxios(
  //   `${config.apiUrlBooking_BookingEndpoint}/getBookings`,
  //   body,
  //   requestOptions
  // );

  return Axios.post(
    `${config.apiUrlBooking_BookingEndpoint}/getBookings`,
    body,
    requestOptions
  ).then(handleResponse);
}

function loadBookingEvents(user, bookingNo) {
  let companyIds = [];

  if (user && user.accounts && user.accounts) {
    user.accounts.forEach(account => {
      companyIds.push(account.id);
    });
  }

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      client: companyIds.join(","),
      password: config.bookingAPIPwd
    }
  };

  const body = {
    bookingno: bookingNo
  };

  // tools.logAxios(
  //   `${config.apiUrlBooking_BookingEndpoint}/GetBookingEvents?json=${tools.uriEncodeString(
  //     JSON.stringify(body)
  //   )}`,
  //   body,
  //   requestOptions
  // );

  return Axios.get(
    `${config.apiUrlBooking_BookingEndpoint}/GetBookingEvents?json=${encodeURI(
      JSON.stringify(body)
    )}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  if (response.status != "200") {
    const error = response.statusText;
    return Promise.reject(error);
  }
  return response.data;
}
